import React from 'react';
import { IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

export const CustomPrevArrow = ({ onClick }: { onClick?: () => void }) => (
  <IconButton
    onClick={onClick}
    sx={{
      position: 'absolute',
      bottom: -60,
      left: '50%',
      transform: 'translateX(-50px)',
      bgcolor: 'background.paper',
      boxShadow: 2,
      zIndex: 2,
      '&:hover': {
        bgcolor: 'grey.100',
        boxShadow: 4
      }
    }}
  >
    <ChevronLeft />
  </IconButton>
);

export const CustomNextArrow = ({ onClick }: { onClick?: () => void }) => (
  <IconButton
    onClick={onClick}
    sx={{
      position: 'absolute',
      bottom: -60,
      left: '50%',
      transform: 'translateX(10px)',
      bgcolor: 'background.paper',
      boxShadow: 2,
      zIndex: 2,
      '&:hover': {
        bgcolor: 'grey.100',
        boxShadow: 4
      }
    }}
  >
    <ChevronRight />
  </IconButton>
);
